import {BaseResponseDTO} from "./base.response.dto";
import {DetalleViajeDTO} from "../detalleViaje.dto";


export class GetDetalleViajeResponseDTO extends BaseResponseDTO {

  success: boolean;
  msg: string;
  data: DetalleViajeDTO;

}
